import { Domain as AuthDomain } from 'auth-common/domain';
import type {} from 'dayjs';
import { dayjs } from '../../shared/utils/date';

import Project = AuthDomain.Object.Project;

export namespace ImmutableEntity {
  export type Props = {
    createdBy: string;
    createdAt: string | Date | dayjs;
  };
  export const Construct = (props: Props): ImmutableEntity => {
    return {
      createdBy: props.createdBy,
      createdAt: dayjs(props.createdAt),
    };
  };
  export const Create = (params: { date?: dayjs; user: string }): ImmutableEntity => {
    const { date = dayjs(new Date()), user } = params;
    return {
      createdBy: user,
      createdAt: date,
    };
  };
}
export type ImmutableEntity = {
  createdBy: string;
  createdAt: dayjs;
};

export namespace MutableEntity {
  export type Props = {
    createdBy: string;
    createdAt: string | Date | dayjs;
    updatedBy: string;
    updatedAt: string | Date | dayjs;
  };
  export const Construct = (props: Props): MutableEntity => {
    return {
      createdBy: props.createdBy,
      createdAt: dayjs(props.createdAt),
      updatedBy: props.updatedBy,
      updatedAt: dayjs(props.updatedAt),
    };
  };
  export const Create = (params: { date?: dayjs; user: string }): MutableEntity => {
    const { date = dayjs(new Date()), user } = params;
    return {
      createdBy: user,
      createdAt: date,
      updatedBy: user,
      updatedAt: date,
    };
  };
  export const Update = ({ date = dayjs(new Date()), cur, user }: { date?: dayjs; cur: MutableEntity; user: string }): MutableEntity => {
    return {
      createdBy: cur.createdBy,
      createdAt: cur.createdAt,
      updatedBy: user,
      updatedAt: date,
    };
  };
}
export type MutableEntity = {
  createdBy: string;
  createdAt: dayjs;
  updatedBy: string;
  updatedAt: dayjs;
};

export namespace SystemImmutableEntity {
  export type Props = {
    createdAt: string | Date | dayjs;
  };
  export const Construct = (props: Props): SystemImmutableEntity => {
    return {
      createdAt: dayjs(props.createdAt),
    };
  };
  export const Create = (params?: { date?: dayjs }): SystemImmutableEntity => {
    const { date = dayjs(new Date()) } = params ?? {};
    return {
      createdAt: date,
    };
  };
}
export type SystemImmutableEntity = {
  createdAt: dayjs;
};

export namespace SystemMutableEntity {
  export type Props = {
    createdAt: string | Date | dayjs;
    updatedAt: string | Date | dayjs;
  };
  export const Construct = (props: Props): SystemMutableEntity => {
    return {
      createdAt: dayjs(props.createdAt),
      updatedAt: dayjs(props.updatedAt),
    };
  };
  export const Create = (params?: { date?: dayjs }): SystemMutableEntity => {
    const { date = dayjs(new Date()) } = params ?? {};
    return {
      createdAt: date,
      updatedAt: date,
    };
  };
  export const Update = ({ date = dayjs(new Date()), cur }: { date?: dayjs; cur: SystemMutableEntity }): SystemMutableEntity => {
    return {
      createdAt: cur.createdAt,
      updatedAt: date,
    };
  };
}
export type SystemMutableEntity = {
  createdAt: dayjs;
  updatedAt: dayjs;
};

// 集約のルートエンティティで利用する
export type AggregationRoot = {
  projectId: Project.Id;
};

export type MergeableEntity = {
  mergedTo?: string;
  mergedAt?: dayjs;
};
